module.exports = __webpack_public_path__ + "img/typhoon_blue.1a77153e.gif";